import { Alert, Button, Flex, Group } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { FormattedMessage } from "react-intl";
import { usePOAStepsStore } from "../../hooks/ui/";
import { ENUMPOASteps } from "../../hooks/ui/poaStepsDataStore";
import { useNavigate, useRouter } from "@tanstack/react-router";
import {
  isFullCredentials,
  useUpdateCustomerData,
} from "../../hooks/ui/customerDataStore";
import {
  formatPoaDate,
  getPoaStatusQueryOptions,
} from "../../hooks/api/useGetPoaStatus";

const PoaExpiredBanner = () => {
  const { customerData } = useUpdateCustomerData();

  const { setStep } = usePOAStepsStore();

  const navigate = useNavigate();
  const router = useRouter();

  const currentPath = router.state.location.pathname;

  const poaValid = customerData.poa?.isValid === true;
  // Only an ended POA needs the last answer date, and a failed read must not take
  // the page down with it, so this stays off the app hook's throwOnError.
  const poaStatus = useQuery({
    ...getPoaStatusQueryOptions(customerData.credentials),
    enabled: !poaValid && isFullCredentials(customerData.credentials),
  });
  // Newest first, so the head is the POA the shown data came from.
  const dataFrom = poaStatus.data?.poas[0]?.lastAnswerAt;

  if (poaValid) {
    return null;
  }

  const handleRenewPOA = () => {
    setStep(ENUMPOASteps.POAINFO);
    navigate({
      to: "/poa-renew",
      search: { from: currentPath },
    });
  };

  return (
    <Flex mb="md" mt="1rem">
      <Alert
        icon={<IconAlertCircle aria-hidden="true" />}
        title={
          <FormattedMessage
            id="app.poaOverview.inactivation.headline"
            defaultMessage="Din fullmakt är inte aktiv"
          />
        }
        role="alert"
        c={"var(--wallet-color-neutrals-black)"}
        __vars={{
          "--alert-bg": "var(--wallet-color-masterbrand-accent-yellow)",
          "--alert-color": "var(--wallet-color-neutrals-black)",
        }}
      >
        <FormattedMessage
          id="app.poaOverview.inactivation.description"
          defaultMessage="Din informationsfullmakt är inte längre aktiv, så vi kan inte uppdatera din pensionsinformation. Det kan bero på att den har gått ut, att du har återkallat den eller att du inte varit aktiv hos oss på ett tag."
        />
        {dataFrom && (
          <>
            {" "}
            <FormattedMessage
              id="app.poaOverview.inactivation.lastUpdated"
              defaultMessage="Informationen nedan är från {date}."
              values={{ date: formatPoaDate(dataFrom) }}
            />
          </>
        )}
        <Group mt="md">
          <Button variant="default" onClick={handleRenewPOA}>
            <FormattedMessage
              id="app.poaOnb.reActivation.CTA"
              defaultMessage="Ge ny fullmakt"
            />
          </Button>
        </Group>
      </Alert>
    </Flex>
  );
};

export default PoaExpiredBanner;
